import { getOffsetTop } from './modules/get-offset-top';
import { CountTo } from './modules/CountTo';

let fired = false;
let counterContainerTopOffset = 0;
let counterContainerBottomOffset = 0;

window.addEventListener('load', init, false);

function init() {
  const counterContainer: Element | null = document.querySelector('.counters');
  if (counterContainer instanceof HTMLElement) {
    counterContainerTopOffset = counterContainer.offsetTop
    counterContainerBottomOffset = counterContainerTopOffset + counterContainer.offsetHeight
  }
}

function isScrolledIntoView() {
  const top = window.scrollY;
  const bottom = top + window.innerHeight;

  return ((counterContainerBottomOffset <= bottom) && (counterContainerTopOffset >= top));
}

function windowScrollHandler () {
  if (!fired && isScrolledIntoView()) {
    fired = true;

    new CountTo('.counter', {
      duration: 5000,
      onComplete: (elem) => {
        window.removeEventListener('scroll', windowScrollHandler, false);
      }
    }).process();
  }
}

window.addEventListener('scroll', windowScrollHandler, false);
